import { useState, useEffect } from 'react';
import { API_BASE_URL } from '../config/api';

let _cache = null;
let _promise = null;

/**
 * Reusable hook that fetches all countries from /api/locations.
 * Results are cached in module scope so repeated mounts don't re-fetch.
 * Each country object has: { id, name, code, region, flag }
 */
export const useCountries = () => {
  const [countries, setCountries] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (_cache) {
      setCountries(_cache);
      setLoading(false);
      return;
    }

    if (!_promise) {
      _promise = fetch(`${API_BASE_URL}/locations`)
        .then(res => {
          if (!res.ok) throw new Error('Failed to fetch countries');
          return res.json();
        })
        .then(data => {
          _cache = data.map(c => ({
            ...c,
            flag: `https://flagcdn.com/w80/${c.code.toLowerCase()}.png`
          }));
          return _cache;
        });
    }

    _promise
      .then(data => {
        setCountries(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('[useCountries]', err);
        setError(err.message);
        setLoading(false);
      });
  }, []);

  return { countries, loading, error };
};
